import { render } from "./ActualIcon.vue?vue&type=template&id=6a182696"
import script from "./ActualIcon.vue?vue&type=script&lang=js"
export * from "./ActualIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__